/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ actor: NonNullable<unknown>, name: NonNullable<unknown> }} Notification_Team_JoinedInputs */



/**
* | output |
* | --- |
* | "{actor} added you to the team {name}" |
*
* @param {Notification_Team_JoinedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notification_team_joined = /** @type {((inputs: Notification_Team_JoinedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Team_JoinedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.actor} hat Sie zum Team ${i?.name} hinzugefügt`)
	return /** @type {LocalizedString} */ (`${i?.actor} added you to the team ${i?.name}`)
});